export default ({color, size}) =>
    <svg t="1729822714901" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
         p-id="3330" width={size} height={size}>
      <path
        d="M132.48 835.2l197.12 5.12a40.32 40.32 0 0 0 29.44-12.16L892.16 296.32a156.8 156.8 0 0 0-217.92-224L104.96 603.2a41.6 41.6 0 0 0-13.12 30.4v160a41.6 41.6 0 0 0 40.64 41.6z m598.72-704A73.6 73.6 0 0 1 832 237.44l-64 64-106.24-104.96zM175.04 651.52L600.96 253.44l108.16 108.16L313.92 756.8l-138.88-3.84zM944 912h-864a41.6 41.6 0 0 0 0 83.2h864a41.6 41.6 0 0 0 0-83.2z"
        p-id="3331" fill={color}></path>
    </svg>
;